const React = require('react');


module.exports = (props) => {
  return (
    <div>
      <div
        disabled={props.disabled}
        onClick={props.onClick}
        className={`layoutRow fhaS fvaC rlv w hmin66 ov r8 bgF.05 dn
          ff$2 cA3A7AC fw5 f15 usN
          (cF|bcF.08|bgF.12)(:h<1|<1.drag):not[.disabled] b2 bs bcF0 ph22 pv5 `
          + (props.className || '')}
      >{props.children}</div>
    </div>
  );
};
